// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './login'

// 引入公共方法
import api from '../../api/api'
import urls from '../../api/url'
import urlParam from '../../assets/js/urlParam'
import dateFilter from '../../assets/js/dateFilter'
import ElementUI from 'element-ui'
import * as utils from 'apec-fe-utils'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)

////按需引入element模块
//import {Table,TableColumn,RadioGroup,RadioButton,Form,FormItem,Upload,Input,Button,Dialog,Message,Loading} from 'element-ui'
//
//Vue.use(Table)
//Vue.use(TableColumn)
//Vue.use(RadioGroup);
//Vue.use(RadioButton);
//Vue.use(Form);
//Vue.use(FormItem);
//Vue.use(Upload);
//Vue.use(Input);
//Vue.use(Button);
//Vue.use(Dialog);
//Vue.use(Loading.directive)

// 注册全局api对象，便于每个组件调用而不用每个组件import
Vue.prototype.api = api;
Vue.prototype.urls = urls;
Vue.prototype.urlParam = urlParam;
Vue.prototype.dateFilter = dateFilter;
console.info(utils)
Vue.prototype.$utils = utils
//Vue.prototype.$message = Message;
//Vue.prototype.$loading = Loading.service

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/login/login_main.js